export default "__VITE_ASSET__f1e6dd54__"